import {connect} from 'react-redux';
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import {selectStoreList} from "../../../globals/state/selector";
import EditPartner from "./EditPartner";

const mapStateToProps = (state, props) => {
    return {
        title:'Edit Partner',
        partner: selector.selectPartner(state),
        storeList: selectStoreList(state),
        error: selector.selectError(state),
        validationMessageList: selector.selectValidationMessageList(state),
        partnerId: props.computedMatch.params.partnerId,
        redirect:selector.selectRedirect(state)
    }
}

const mapDispatchToProps = {
    findPartner: action.findPartner,
    editPartner: action.editPartnerFormValue,
    savePartner: action.savePartner,
    pushValidationList: action.pushValidationList,
    clearState:action.clearState
}

export default connect(mapStateToProps, mapDispatchToProps)(EditPartner)


// WEBPACK FOOTER //
// ./src/modules/partner/component/edit/EditPartnerContainer.js